import widgetSpotFromUrl from '@/utils/widgetSpotFromUrl'

// The page's spot from its URL (see utils/widgetSpotFromUrl). WidgetStore reads the URL itself
// rather than the spot globals, which other JWX bundles on the page replace with their own.
export default () => widgetSpotFromUrl()
